(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var PAGE = document.getElementById('hb-temple-page');
  if (!PAGE) return;
  var CONFIG_NODE = document.getElementById(
  PAGE.getAttribute('data-config-id')
);

var CFG = {};

if (CONFIG_NODE) {
  try {
    CFG = JSON.parse(CONFIG_NODE.textContent);
  } catch (configError) {
    console.error(
      'HB Temple configuration JSON is invalid:',
      configError
    );

    CFG = {};
  }
}
  var CDN = CFG.cdnBase || 'https://cdn.shopify.com/s/files/1/0589/5123/7792/files/';
  var WORK_IMG = CFG.workImages || {};

  /* ---------------- responsive Shopify CDN image helper ------------------ */
  function imageBase(file) {
    if (!file) return '';
    return /^https?:\/\//i.test(file) ? file : CDN + file;
  }

  function imageWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function img(file, alt, sizes, w, h) {
    var base = imageBase(file);
    return '<img src="' + imageWidth(base, 600) + '" srcset="' +
      imageWidth(base, 400) + ' 400w, ' + imageWidth(base, 600) + ' 600w, ' + imageWidth(base, 900) + ' 900w" ' +
      'sizes="' + sizes + '" alt="' + alt + '" loading="lazy" decoding="async" width="' + w + '" height="' + h + '">';
  }

  /* ------------------------------- content ------------------------------- */
  /* Real installation photographs. `key` maps to WORK_IMG below, which the
     build fills with a Shopify CDN URL (or an embedded crop in this preview).
     City, size and price range are per-project copy — edit freely. */
  var WORK = [
    ['w01', 'Jaipur, Rajasthan',       '6-ft peacock inlay temple',        'Premium inlay work',        '6 ft', 'Premium Inlay'],
    ['w02', 'Mumbai, Maharashtra',     'Radha Krishna temple in niche',    'Hand carving with inlay',  '5 ft', 'Premium Inlay'],
    ['w03', 'Hyderabad, Telangana',    'Triple-arch pooja room',           'Complete pooja room',       '8 ft', 'Full Pooja Room'],
    ['w04', 'Delhi NCR',               'Jali-screen pooja room',           'Complete pooja room',       '8 ft', 'Full Pooja Room'],
    ['w05', 'Ahmedabad, Gujarat',      'Arched temple with cow inlay',     'Semi-precious stone inlay',        '5 ft', 'Premium Inlay'],
    ['w06', 'Indore, Madhya Pradesh',  'Gold-detailed pooja room',         'Hand-painted detailing',   '8 ft', 'Hand-Painted'],
    ['w07', 'Bengaluru, Karnataka',    '6-ft Om temple with pillars',      'Hand-carved marble',      '6 ft', 'Pure White Carved'],
    ['w08', 'Pune, Maharashtra',       'Tree-of-life inlay temple',        'Mother-of-pearl inlay',        '5 ft', 'Premium Inlay'],
    ['w09', 'Kolkata, West Bengal',    'Shri Yantra carved temple',        'Hand-carved marble',      '6 ft', 'Pure White Carved'],
    ['w10', 'Surat, Gujarat',          'Illuminated pooja room',           'Complete pooja room','9 ft', 'Full Pooja Room'],
    ['w11', 'Lucknow, Uttar Pradesh',  'Gold vine carved temple',          'Gold-painted detailing',    '6 ft', 'Hand-Painted'],
    ['w12', 'Nagpur, Maharashtra',     'Ram Darbar pooja room',            'Complete pooja room',       '8 ft', 'Full Pooja Room']
  ];


  var SIZES = [
    ['https://cdn.shopify.com/s/files/1/0589/5123/7792/files/imgi_378_image_119617ed-0def-4894-9003-9ae24051cf5c.webp?v=1786793295', '3', 'A compact pooja space or wall niche', '₹2.85 lakh', '3-ft Temple'],
    ['https://cdn.shopify.com/s/files/1/0589/5123/7792/files/imgi_366_image_e1c0760c-0159-443f-b290-7091e09ff512.webp?v=1786793389', '4', 'A dedicated temple wall', '₹4.25 lakh', '4-ft Temple'],
    ['https://cdn.shopify.com/s/files/1/0589/5123/7792/files/eqweee32reqwfw_15777020-fb65-4899-86f8-cf38a16a8463.jpg?v=1786793802', '5', 'A larger pooja area', '₹5.5 lakh', '5-ft Temple'],
    ['https://cdn.shopify.com/s/files/1/0589/5123/7792/files/131131313_b739a763-cf8c-413f-8a36-3d015b36849f.jpg?v=1786793803', '6', 'A full pooja room', '₹6.5 lakh +', '6-ft+ Temple']
  ];

  var FAQ = [
    ['What does a custom marble temple cost?', 'Projects start at about ₹2.85 lakh for a 3-ft temple. The final figure depends on width, marble, carving depth, inlay or painted work, your city and installation. You receive a written estimate before anything is confirmed.'],
    ['Can it be built to my exact dimensions?', 'Yes — every temple is made to order around your wall width, ceiling height and floor plan. Send measurements and photographs and we design to them.'],
    ['How long does it take?', 'A few weeks from approved design to dispatch, depending on size and carving detail. We confirm the timeline along with your estimate.'],
    ['Do you deliver and install across India?', 'Yes. Each piece is crated for long-distance marble transport, and we coordinate delivery and installation through to final placement.'],
    ['Can you work with my architect or interior designer?', 'Regularly. We share drawings, finishes and installation requirements directly with your team.'],
    ['What do I pay to start?', 'Nothing. The consultation and the design recommendation are free. An advance is taken only once you approve the design and estimate.']
  ];

  /* -------------------------------- build -------------------------------- */
  var RAIL_SIZES = '(min-width:1024px) 360px, (min-width:768px) 340px, 82vw';

  WORK.forEach(function (w, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'card hb-open';
    b.dataset.loc = 'work';
    b.dataset.size = w[4];
    b.dataset.style = w[5];
    b.dataset.pic = WORK_IMG[w[0]] || '';
    b.dataset.picLabel = w[2];
    b.innerHTML =
      '<span class="card__img"><img src="' + (WORK_IMG[w[0]] || '') + '" alt="' +
        w[2] + ' installed in ' + w[1] + '" loading="lazy" decoding="async" width="420" height="525"></span>' +
      '<span class="card__top"><span class="card__city">' + w[1] + '</span>' +
      '<span class="card__n">' + String(i + 1) + '/' + String(WORK.length) + '</span></span>' +
      '<span class="card__t">' + w[2] + '</span>' +
      '<span class="card__m">' + w[4] + ' wide · ' + w[3] + '</span>' +
      '<span class="card__cta">Discuss a similar temple</span>';
    $('#rail').appendChild(b);
  });

  SIZES.forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'stop hb-open';
    b.dataset.loc = 'ruler';
    b.dataset.size = s[4];
    b.dataset.stop = '1';
    b.dataset.pic = imageWidth(imageBase(s[0]), 600);
    b.dataset.picLabel = s[4];
    b.innerHTML =
      '<span class="stop__img">' + img(s[0], s[1] + ' ft custom marble temple', RAIL_SIZES, 600, 750) + '</span>' +
      '<span class="stop__meta">' +
        '<span class="stop__lbl">Starting from</span>' +
        '<span class="stop__price">' + s[1] + ' ft <i>|</i> ' + s[3] + '</span>' +
        '<span class="stop__for">' + s[2] + '</span>' +
        '<span class="stop__go">Discuss this width</span>' +
      '</span>';
    $('#scale').appendChild(b);
  });

  FAQ.forEach(function (f, i) {
    var d = document.createElement('div');
    d.className = 'faq__i';
    d.innerHTML =
      '<h3 style="margin:0"><button type="button" class="faq__b" id="fb' + i + '" aria-expanded="false" aria-controls="fp' + i + '"></button></h3>' +
      '<div class="faq__p" id="fp' + i + '" role="region" aria-labelledby="fb' + i + '" hidden><p></p></div>';
    d.querySelector('button').textContent = f[0];
    d.querySelector('p').textContent = f[1];
    $('#faq').appendChild(d);
  });

  /* ------------------------------ swipe bars ----------------------------- */
  function bindSwipe(railSel, barSel) {
    var rail = $(railSel), bar = $(barSel);
    if (!rail || !bar) return;
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? rail.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (pct * 400) + '%)';
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  bindSwipe('#rail', '#rail-bar');
  bindSwipe('#scale', '#scale-bar');

  /* -------------------------------- track -------------------------------- */
  function track(e, d) {
    d = d || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: e }, d));
    console.log('[track] ' + e, d);
  }

  /* -------------------------- hidden field capture ----------------------- */
  var F = $('#lead');
  if (!F) {
  console.error('HB Temple form #lead was not found.');
  return;
}
  (function () {
    var q = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var f = $('[name=' + k + ']', F);
      if (f) f.value = q.get(k) || '';
    });
    $('[name=sourcePage]', F).value = location.href;
    $('[name=userAgent]', F).value = navigator.userAgent;
  })();

  /* -------------------------------- modal -------------------------------- */
  var DESK = $('#hero-home'),      /* desktop: form sits in the hero card   */
      MOB  = $('#consult-home'),   /* mobile: form sits in its own section  */
      MOUNT = $('#mount'),
      MODAL = $('#modal'),
      lastFocus = null,
      isOpen = false;

  if (!DESK || !MOB || !MOUNT || !MODAL) {
    console.error('HB Temple required elements are missing:', {
      heroHome: !!DESK,
      consultHome: !!MOB,
      mount: !!MOUNT,
      modal: !!MODAL
    });
    return;
  }

  /* The form is a single node with two resting places. Which one depends on
     the viewport, so it is never duplicated and never loses typed values. */
  var wide = window.matchMedia('(min-width:1024px)');
  function home() { return wide.matches ? DESK : MOB; }
  function park() {
    if (isOpen || F.parentNode === home()) return;
    home().appendChild(F);
    $('[name=formLocation]', F).value = wide.matches ? 'hero_section' : 'consultation_section';
    if (typeof resetForm === 'function') resetForm();
  }
  park();
  if (wide.addEventListener) wide.addEventListener('change', park);

  function openModal(loc) {
    if (F.parentNode !== MOUNT) MOUNT.appendChild(F);
    lastFocus = document.activeElement;
    MODAL.classList.add('is-open');
    MODAL.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock');
    isOpen = true;
    $('[name=formLocation]', F).value = loc || 'modal';
    track('hb_form_open', { form_location: loc || 'modal' });
    /* Focus the dialog itself, not a field — on mobile, focusing an input
       pops the on-screen keyboard before the user has asked for it. */
    setTimeout(function () {
      var box = MODAL.querySelector('.modal__box');
      if (box) box.focus();
    }, 60);
  }

  function closeModal() {
    home().appendChild(F);
    $('[name=formLocation]', F).value = wide.matches ? 'hero_section' : 'consultation_section';
    MODAL.classList.remove('is-open');
    MODAL.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock');
    isOpen = false;
    resetForm();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  MODAL.addEventListener('click', function (e) {
    if (e.target.closest('[data-x]')) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),textarea', MODAL)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], b = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); b.focus(); }
    else if (!e.shiftKey && document.activeElement === b) { e.preventDefault(); a.focus(); }
  });

  /* --------------------------------- form -------------------------------- */
  var busy = false;

  function step(n, silent) {
    CUR = n;
    $('[data-step="1"]', F).hidden = n !== 1;
    $('[data-step="2"]', F).hidden = n !== 2;
    $('[data-count]').textContent = 'Step ' + n + ' of 2';
    $('#m-title').textContent = n === 1 ? 'Talk to our temple expert' : 'Almost there';
    if (!silent) {
      var body = $('.modal__body');
      if (body) body.scrollTop = 0;
    }
  }

  function bad(el, msg) {
    var w = el.closest('.f') || el.closest('fieldset');
    if (w) {
      w.classList.add('bad');
      var e = $('.err', w);
      if (e) e.textContent = msg;
    }
    return false;
  }

  function clearErr(el) {
    var w = el.closest('.f') || el.closest('fieldset');
    if (w) {
      w.classList.remove('bad');
      var e = $('.err', w);
      if (e) e.textContent = '';
    }
  }

  function ok1() {
    var v = true, first = null;
    var n = $('#q-name'), p = $('#q-phone'), c = $('#q-city');
    if (n.value.trim().length < 2) { v = bad(n, 'Please enter your name.'); first = first || n; }
    if (!/^[6-9]\d{9}$/.test(p.value.trim())) { v = bad(p, 'Enter a 10-digit mobile number.'); first = first || p; }
    if (!c.value.trim()) { v = bad(c, 'Please enter your city.'); first = first || c; }
    if (!$('input[name=userType]:checked', F)) {
      $('.err', $('[data-set=userType]', F)).textContent = 'Please pick one.';
      v = false;
      first = first || $('input[name=userType]', F);
    }
    if (first) first.focus();
    return v;
  }


  /* Below-minimum budgets cannot be submitted. */
  function belowMin() {
    var b = $('input[name=budget]:checked', F);
    return !!(b && b.hasAttribute('data-below'));
  }
  function syncBudget() {
    var note = $('[data-belowmin]', F);
    var blocked = belowMin();
    if (note) note.hidden = !blocked;
    var sub = $('[data-submit]', F);
    if (sub) { sub.disabled = blocked; sub.setAttribute('aria-disabled', blocked ? 'true' : 'false'); }
  }

  function ok2() {
    var v = true;
    ['budget', 'timeline'].forEach(function (k) {
      var s = $('[data-set=' + k + ']', F), e = $('.err', s);
      if (!$('input[name=' + k + ']:checked', F)) { e.textContent = 'Please pick one.'; v = false; }
      else { e.textContent = ''; }
    });
    if (belowMin()) v = false;
    return v;
  }

  function values() {
    var v = {};
    $$('input,textarea', F).forEach(function (f) {
      if (!f.name) return;
      if (f.type === 'radio' && !f.checked) return;
      v[f.name] = f.value;
    });
    var phone = String(v.phone || '').replace(/\D/g, '');
    if (phone.length === 11 && phone.charAt(0) === '0') phone = phone.substring(1);
    if (phone.length === 10) phone = '91' + phone;
    v.phone = phone;
v.whatsapp = phone ? '+' + phone : '';

var genericFormLocations = [
  'hero_section',
  'space',
  'close',
  'consultation_section'
];

/*
 * Always force Temple Style to "None" for generic forms.
 * Any old, hidden or selected value will be removed.
 */
if (genericFormLocations.indexOf(v.formLocation) !== -1) {
  v.templeStyle = 'None';
}

v.submittedAt = new Date().toISOString();
    return v;
  }

  function goStep2() {
  if (!ok1()) return;

  var locationField = $('[name=formLocation]', F);
  var formLocation = locationField ? locationField.value : '';

  /*
   * Keep "Enquiring about" only when the form was opened from:
   * 1. Installation cards
   * 2. Temple width cards
   */
  var shouldKeepEnquiry =
    formLocation === 'work' ||
    formLocation === 'ruler';

  if (!shouldKeepEnquiry) {
    clearCtx();
  }

  track('hb_form_step1_complete', {
    user_type: $('input[name=userType]:checked', F).value,
    form_location: formLocation
  });

  if (!isOpen) {
    openModal(
      wide.matches
        ? 'hero_section'
        : 'consultation_section'
    );
  }

  step(2);
}

  function submitForm() {
    if (busy || belowMin() || !ok2()) return;
    var btn = $('[data-submit]', F), d = values();
    var alertBox = $('[data-alert]', F);
    if (!CFG.endpoint || CFG.endpoint.indexOf('/exec') === -1) {
      alertBox.hidden = false;
      alertBox.textContent = 'The form is not connected yet. Please add the Google Apps Script Web App URL in the section settings.';
      return;
    }
    busy = true;
    F.classList.add('busy');
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Sending…';
    alertBox.hidden = true;
    alertBox.textContent = '';
    track('hb_form_submit', { form_location: d.formLocation });

    fetch(CFG.endpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(d)
    })
      .then(function () {
        try { sessionStorage.setItem('hbTempleLead', JSON.stringify(d)); } catch (ignore) {}
        track('hb_lead_saved', {
          form_location: d.formLocation, budget: d.budget, timeline: d.timeline,
          temple_size: d.templeSize, temple_style: d.templeStyle
        });
        var target = CFG.thankYouUrl || '/pages/marble-temple-thank-you?submitted=1';
        location.assign(target);
      })
      .catch(function () {
        busy = false;
        F.classList.remove('busy');
        btn.disabled = false;
        btn.textContent = label;
        alertBox.hidden = false;
        alertBox.textContent = 'We could not submit your request. Please try again, or contact us on WhatsApp.';
        alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
  }

  /* Delegated so the buttons keep working after the form is moved between the
     hero card, the consultation section and the modal. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-next]'))   { e.preventDefault(); e.stopPropagation(); goStep2();   return; }
    if (e.target.closest('[data-back]'))   { e.preventDefault(); e.stopPropagation(); step(1);     return; }
    if (e.target.closest('[data-submit]')) { e.preventDefault(); e.stopPropagation(); submitForm(); }
  });
  /* Implicit submission (Enter / the keyboard's Go key) must follow the step
     the user is actually on, not always attempt a final submit. */
  var CUR = 1;
  F.addEventListener('submit', function (e) {
    e.preventDefault();
    if (CUR === 1) goStep2(); else submitForm();
  });

  $('#q-phone').addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '').slice(0, 10);
  });

  $$('input,textarea', F).forEach(function (i) {
    i.addEventListener('input', function () { clearErr(i); });
    i.addEventListener('change', function () { clearErr(i); if (i.name === 'budget') syncBudget(); });
  });
  syncBudget();

  /* ---------------------- size / style pass-through ---------------------- */
  function setPic(src, label) {
    var fig = $('.pickpic', F);
    if (!fig) return;
    if (!src) { fig.hidden = true; return; }
    $('img', fig).src = src;
    $('img', fig).alt = label || '';
    $('figcaption', fig).textContent = label || '';
    fig.hidden = false;
  }

  /* Wipe every trace of a previous CTA so each button opens the form with
     only its own context — no leftover size, style, chip or photograph. */
  function clearCtx() {
    var sz = $('[name=templeSize]', F);
    if (sz) sz.value = '';
    $$('input[name=templeStyle]', F).forEach(function (r) { r.checked = false; });
    $$('[data-chip]').forEach(function (c) { c.hidden = true; c.innerHTML = ''; });
    setPic('');
    $$('[data-hb-style-card], .stop').forEach(function (n) { n.classList.remove('on', 'is-selected'); });
  }

  /* A complete reset: fields, choices, errors, step and context. Runs when a
     CTA opens the form and again when it closes, so the inline copy in the
     consultation section is never left holding a previous enquiry. */
  function resetForm() {
    $$('input[type=text],input[type=email],input[type=tel],textarea', F)
      .forEach(function (i) { i.value = ''; });
    $$('input[type=radio]', F).forEach(function (r) { r.checked = false; });
    $$('.f', F).forEach(function (f) { f.classList.remove('bad'); });
    $$('.err', F).forEach(function (e) { e.textContent = ''; });
    var alertBox = $('[data-alert]', F);
    if (alertBox) { alertBox.hidden = true; alertBox.textContent = ''; }
    clearCtx();
    syncBudget();
    busy = false;
    F.classList.remove('busy');
    step(1, true);
  }

  function ctx(kind, val) {
    if (!val) return;
    if (kind === 'size') {
      $('[name=templeSize]', F).value = val;
    } else {
      var r = $('input[name=templeStyle][value="' + val + '"]', F);
      if (r) r.checked = true;
    }
    var chip = $('[data-chip=' + kind + ']');
    chip.hidden = false;
    chip.innerHTML = (kind === 'size' ? 'Size: ' : 'Style: ') + '<b></b>';
    chip.querySelector('b').textContent = val;
  }

  /* ------------------------------ delegation ----------------------------- */
  document.addEventListener('click', function (e) {
    /* Form controls are handled above — never treat them as an open-form CTA. */
    if (e.target.closest('[data-next],[data-back],[data-submit],[data-x]')) return;
    var o = e.target.closest('.hb-open');

if (o) {
  if (o.tagName === 'A') {
    e.preventDefault();
  }

  resetForm();

  var formLocation = o.dataset.loc || 'cta';

  /*
   * Context is allowed only for:
   * work  = Temples we built for homes like yours
   * ruler = How wide is your space?
   */
  var showEnquiryContext =
    formLocation === 'work' ||
    formLocation === 'ruler';

  /*
   * Generic mobile buttons scroll to the inline form.
   * No enquiry image, size chip or style chip is shown.
   */
  if (o.dataset.jump && !wide.matches) {
    var target = $(o.dataset.jump);

    if (target) {
      clearCtx();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      $('[name=formLocation]', F).value =
        formLocation + '_scroll';

      track('hb_form_open', {
        form_location: formLocation + '_scroll'
      });

      return;
    }
  }

  /*
   * Add enquiry context only for installation and width cards.
   */
  if (showEnquiryContext) {
    setPic(
      o.dataset.pic || '',
      o.dataset.picLabel || ''
    );

    if (o.dataset.size) {
      ctx('size', o.dataset.size);
    }

    if (o.dataset.style) {
      ctx('style', o.dataset.style);
    }

    if (o.dataset.stop) {
      $$('.stop').forEach(function (stop) {
        stop.classList.remove('on');
      });

      o.classList.add('on');
    }
  } else {
    clearCtx();
  }

  openModal(formLocation);
  step(1);

  return;
}
    var w = e.target.closest('[data-wa]');
    if (w) {
      track('hb_whatsapp_click', { placement: w.dataset.wa });
      var currentHref = w.getAttribute('href') || '';
      if (currentHref === '#' || currentHref === '') {
        e.preventDefault();
        var phone = String(CFG.whatsapp || '').replace(/\D/g, '');
        if (phone) {
          var text = 'Hello, I would like to know more about a premium marble temple for my home.';
          window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
        }
      }
      return;
    }
    var m = e.target.closest('.hdr__menu');
    if (m) {
      var nav = $('#hdr-nav');
      var open = m.getAttribute('aria-expanded') === 'true';
      m.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (nav) nav.classList.toggle('is-open', !open);
      return;
    }
    if (e.target.closest('#hdr-nav a')) {
      var mb = $('.hdr__menu'), nv = $('#hdr-nav');
      if (mb) mb.setAttribute('aria-expanded', 'false');
      if (nv) nv.classList.remove('is-open');
    }

    var q = e.target.closest('.faq__b');
    if (q) {
      var open = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.getElementById(q.getAttribute('aria-controls')).hidden = open;
    }
  });

  /* -------------------------------- reveal ------------------------------- */
  var rev = $$('[data-r]');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    rev.forEach(function (n) { io.observe(n); });
  } else {
    rev.forEach(function (n) { n.classList.add('in'); });
  }

  step(1, true);
})();